import { Action } from '@ngrx/store';

export const ADD_COMMENT_ACTION = 'ADD_COMMENT_ACTION';

export class AddCommentActions implements Action {
  readonly type = ADD_COMMENT_ACTION;
  constructor(public payload: any) {}
}
